import { snackBar } from '../utils/snackbar';
class Form {
  constructor(form) {
    this.blockId = form.dataset.blockId;
    this.formData = d4l[`form_${this.blockId}`];
    this.mailto = this.formData.mailto;
    this.subject = this.formData.subject;
    this.page = this.formData.page;
    this.successMessage = this.formData.successMessage;
    this.errorMessage = this.formData.errorMessage;
    this.element = form;
    this.submitButton = form.querySelector('.form__submit');

    form.addEventListener('submit', (e) => this.onSubmit(e, form));
  }
  /* 
  isHoneypotted: returns true if the honeypot was filled by an agent
  - If an automated agent fills all the elements, then the honeypot is also filled and the agent has fallen for the "trap".
  */
  isHoneypotted(form) {
    const hp = form.querySelector('.form__hp');
    return hp && hp.value.length > 0;
  }

  isSpam(form) {
    return this.isHoneypotted(form);
  }

  getBody(form) {
    let message = `A form was submitted on D4L website from: ${this.page} <br><br>`;
    for (var element of form.elements) {
      const label = element.parentNode.querySelector('label');
      if (element.type !== 'submit' && element.className.includes('sc-d4l')) {
        message += `${label.textContent}: `;
        if (element.type.match(/select/)) {
          message += element.options[element.selectedIndex].text;
        } else if (element.type === 'checkbox') {
          message += element.checked;
        } else {
          message += element.value;
        }
        message += '<br><br>';
      }
    }
    message += '<br>End of form.';
    return message;
  }

  onSubmit(event, form) {
    event.preventDefault();
    this.submitButton.isLoading = true;

    if (this.isSpam(form)) {
      this.onSuccess();
      return false;
    }

    const input = JSON.stringify({
      to: this.mailto,
      subject: this.subject,
      body: this.getBody(form),
    });

    const xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://www.data4life.care/api/v1/public/contact');
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.send(input);

    xhr.onload = (err) => {
      const snackBar = this.element.parentNode.querySelector('d4l-snack-bar');
      if (snackBar) {
        snackBar.remove();
      }

      if (xhr.status !== 204) {
        this.onError();
        this.submitButton.isLoading = false;
      } else {
        this.onSuccess();
      }
    };
  }

  onSuccess() {
    this.element.parentNode.insertBefore(snackBar(this.successMessage), this.element);
    this.element.remove();
  }

  onError() {
    this.element.parentNode.insertBefore(snackBar(this.errorMessage, 'error'), this.element);
  }
}

const init = () => {
  [...document.querySelectorAll('.js-form')].forEach((el) => new Form(el));
};

export { init };
